<div class="bpiconbox">
  <button mat-icon-button *ngFor="let p of punkte|async" (click)="showDetails(p)">
    <svg-icon matBadge="{{p.level}}"
              matTooltip="{{getTooltip(p)}}">favorit-voll
    </svg-icon>
  </button>
</div>
